import { lazyNamed } from 'src/utils/lazyNamed';
import UserDetails from './containers/UserDetails';

const Users = {
  UsersList: lazyNamed(() => import('./containers/UsersList'), 'UsersList'),
  UserForm: lazyNamed(() => import('./containers/UserForm'), 'UserForm'),
  UserDetails,
};

export default Users;
